/** Shared OpenMapTiles road classes for basemap paint and ordinary name filtering. Unknowns remain provider-owned. */
export const ROAD_LABEL_CLASSES = {
  motorwaysHighways: ['motorway', 'trunk'],
  arterialRoads: ['primary', 'secondary'],
  collectorRoads: ['tertiary'],
  localRoads: [
    'minor',
    'residential',
    'service',
    'track',
    'street',
    'street_limited',
    'living_street',
    'path',
    'pedestrian',
  ],
} as const;
export type RoadLabelTier = keyof typeof ROAD_LABEL_CLASSES;

export const ROAD_LABEL_TIERS = [
  ['motorwaysHighways', 'Motorways / Highways'],
  ['arterialRoads', 'Arterial roads'],
  ['collectorRoads', 'Collector roads'],
  ['localRoads', 'Local roads'],
] as const;

/** Explicit class choices supersede the retired master; absence inherits its effective value. */
export function effectiveRoadLabelTiers(
  tiers: Readonly<Record<RoadLabelTier, boolean>> | undefined,
  legacyVisible: boolean,
): Readonly<Record<RoadLabelTier, boolean>> {
  return (
    tiers ?? {
      motorwaysHighways: legacyVisible,
      arterialRoads: legacyVisible,
      collectorRoads: legacyVisible,
      localRoads: legacyVisible,
    }
  );
}
